export default "__VITE_ASSET__BKaEPnft__"